import { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Flex, Text } from '@eqi-investimentos/react';
import { CardOpportunityProps } from '../../interface/secondaries';
import { Drawer } from '@/components/molecules/Drawer';
import { InfoDetailsOpportunity } from '../InfoDetailsOpportunity';
export const DrawerDetailsOpportunity: FC<DrawerDetailsOpportunityProps> = ({
  id,
  data
}) => {
  const {
    t: i18n
  } = useTranslation('common');
  return <Drawer id={id} showHeaderBackButton={false} headerProps={{
    pt: '4xl',
    px: '2xl'
  }} bodyProps={{
    pt: 'm',
    pb: '4rem',
    px: '2xl'
  }} closeButtonProps={{
    right: '2.1875rem',
    top: '5xl'
  }} showCustomButton={false} showIconButton={false} headerContent={<Flex w="full" flexDir="row" justifyContent="space-between" alignItems="center">
          <Text size="xl" color="content.primary" textTransform="capitalize">
            {i18n('attributes.details')}
          </Text>
        </Flex>} data-sentry-element="Drawer" data-sentry-component="DrawerDetailsOpportunity" data-sentry-source-file="index.tsx">
      <InfoDetailsOpportunity data={data} data-sentry-element="InfoDetailsOpportunity" data-sentry-source-file="index.tsx" />
    </Drawer>;
};
interface DrawerDetailsOpportunityProps {
  id?: string;
  data: CardOpportunityProps;
}